import axios from "axios";

export default axios.create({
  baseURL: "https://api.conexaonr.com.br/api/v1",
});

// export default axios.create({
//   baseURL: "http://localhost:3333/api/v1",
// });
